import { useTranslation } from 'react-i18next';
import { Dialog, TextV2 } from '@insights-ltd/design-library/components';
import { Box } from '@mui/material';
import Evaluator from 'components/Svgs/ASSET-Evaluator.svg';
import { spacingSizeMap } from '@insights-ltd/design-library/themes';

const ConfirmDialog = ({
  open,
  handleClose,
}: {
  open: boolean;
  handleClose: () => void;
}) => {
  const { t } = useTranslation();
  return (
    <Dialog
      onClose={handleClose}
      open={open}
      content={
        <Box
          sx={(theme) => ({
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            p: {
              textAlign: 'center',
            },
            svg: {
              marginBottom: theme.spacing(spacingSizeMap.S),
            },
          })}
        >
          <img
            alt={t(
              'ui.event-management.learners.purchase-profiles.confirm-purchase.modal-heading',
            )}
            src={Evaluator}
          />
          <TextV2 component="p" variant="bodyBold" color="textPrimary">
            {t(
              'ui.event-management.learners.purchase-profiles.confirm-purchase.modal-sub-heading',
            )}
          </TextV2>
          <TextV2 component="p" variant="bodyBold" color="textSecondary">
            {t(
              'ui.event-management.learners.purchase-profiles.confirm-purchase.modal-content.email',
            )}{' '}
            {t(
              'ui.event-management.learners.purchase-profiles.confirm-purchase.modal-content.charge',
            )}
          </TextV2>
        </Box>
      }
      secondaryButtonText={t(
        'ui.event-management.learners.purchase-profiles.confirm-purchase.close-button.label',
      )}
      title={t(
        'ui.event-management.learners.purchase-profiles.confirm-purchase.modal-heading',
      )}
    />
  );
};

export default ConfirmDialog;
